import React from "react";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "../../data/content";

export const WhoIsJT = () => {
  return (
    <section id="story" data-testid="story-section" className="grid md:grid-cols-2 min-h-[90vh]">
      <div className="relative min-h-[60vh] md:min-h-full overflow-hidden">
        <img
          src={IMAGES.portrait}
          alt="Jaron Thames"
          className="absolute inset-0 w-full h-full object-cover film-warm"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-matte/20 to-matte/60 md:to-matte/30" />
      </div>

      <div className="flex items-center px-6 md:px-12 lg:px-20 py-20">
        <div className="max-w-xl">
          <Reveal>
            <p className="eyebrow mb-5">The Story</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="heading text-5xl sm:text-6xl lg:text-7xl text-cream mb-8">
              Still Writing It.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="space-y-5 text-cream/75 leading-relaxed">
              <p>Nobody really plans for their journey to look like this.</p>
              <p>
                One season in Ireland. Another in Newcastle. New cities. New people. New
                lessons.
              </p>
              <p>
                Basketball has taken me around the world, but the mission has never changed:
                keep growing, keep getting better, keep chasing the dream.
              </p>
              <p>Because there isn't one blueprint for success. This is my path.</p>
              <p className="font-accent text-3xl text-stone -rotate-2 pt-2">One Of None.</p>
            </div>
          </Reveal>
          <Reveal delay={0.3}>
            <button
              data-testid="story-cta"
              onClick={() => document.getElementById("journey")?.scrollIntoView({ behavior: "smooth" })}
              className="btn-secondary mt-10"
            >
              Read My Story <ArrowRight size={16} />
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
